import React from 'react'
import { Col, Row } from 'react-bootstrap'

function UserPersonalDetailsForm({handleSubmit , submitForm , register , t , errorMessage , errors }) {
    return (
        <div id="personalDtlTab" className="account-section hidden">
            <h4>{t("personalDetails")}</h4>
            <form onSubmit={handleSubmit((data) => submitForm(data))}>
                <div className="personal-details-form-wrap box">
                    <div >
                        <Row>
                            <Col xs="12" md="6">
                                <label htmlFor="fullNameInput"> {t("FullName")}</label>
                                <input
                                    name="fullNameInput"
                                    {...register("fullNameInput", {
                                        required: t("Required"),
                                        pattern: {
                                            value: new RegExp(t("FullNameRegex")),
                                            message: t("FullNameRegexMsg"),
                                        },
                                    })}

                                />
                                <span className="error">{errors.fullNameInput?.message}</span>
                            </Col>
                            <Col xs="12" md="6">
                                <label htmlFor="PhoneInput"> {t("Phone")}</label>
                                <input
                                    name="PhoneInput"
                                    {...register("PhoneInput", {
                                        required: t("Required"),
                                        pattern: {
                                            value: new RegExp(t("PhoneRegex")),
                                            message: t("PhoneRegexMsg"),
                                        },
                                    })}

                                />
                                <span className="error">{errors.PhoneInput?.message}</span>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs="12" md="6">
                                <label htmlFor="EmailInput"> {t("Email")}</label>
                                <input
                                    name="EmailInput"
                                    {...register("EmailInput", {
                                        required: t("Required"),
                                        pattern: {
                                            value: new RegExp(t("EmailRegex")),
                                            message: t("EmailRegexMsg"),
                                        },
                                    })}

                                />
                                <span className="error">{errors.EmailInput?.message}</span>
                            </Col>
                            

                        </Row>
                        <Row>
                            <Col xs="12" md="6">
                                <input
                                    type="submit"
                                    className="btn"
                                    value={t("updateDetails")}
                                />
                            </Col>
                        </Row>


                    </div>
                </div>
            </form>
            <div className={!errorMessage ? "hidden" : "error-msg box"}>
                {errorMessage}
            </div>

        </div>)
}

export default UserPersonalDetailsForm